<div id="embedMenu">
  <div id="embedMenuInner">
    <app-dark-theme></app-dark-theme>
    <app-auto-rotate></app-auto-rotate>
    <app-main-view-toggle></app-main-view-toggle>
    <app-animate-event></app-animate-event>
    <app-animate-camera></app-animate-camera>
    <app-experiment-link></app-experiment-link>
  </div>
</div>
